// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { sparseItemSchema } from '@/sparse/api/types';
import { z } from 'zod';

const validationErrorFieldSchema = z.object({
  fieldName: z.string(),
  error: z.string(),
  errorCode: z.number(),
});

const processedItemImportDataSchema = z.object({
  itemName: z.string(),
  index: z.number(),
  created: z.boolean(),
  validatedItem: sparseItemSchema.nullable(),
  errors: z.array(validationErrorFieldSchema),
});

const rowValidationErrorSchema = z.object({
  index: z.number(),
  errors: z.array(validationErrorFieldSchema),
});

export const uploadItemDataResponseSchema = z.object({
  data: z.object({
    success: z.boolean(),
    items: z.array(processedItemImportDataSchema),
    structureErrors: z.array(validationErrorFieldSchema),
    rowErrors: z.array(rowValidationErrorSchema),
  }),
});

export type ItemDataUploadResult = z.infer<
  typeof uploadItemDataResponseSchema
>['data'];

export type ProcessedItemImportData = z.infer<
  typeof processedItemImportDataSchema
>;

export async function uploadItemData(
  formData: FormData
): Promise<ItemDataUploadResult> {
  const url = '/v1/import/item-data';
  const response = await api.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const parsed = await parseResponse(
    uploadItemDataResponseSchema,
    response.data,
    {
      schemaName: 'UploadItemData',
      endpoint: url,
    }
  );
  return parsed.data;
}
